import script from "./AllCoupons.vue?vue&type=script&setup=true&lang=js"
export * from "./AllCoupons.vue?vue&type=script&setup=true&lang=js"

import "./AllCoupons.vue?vue&type=style&index=0&id=06f52003&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f52003"]])

export default __exports__